import { useState } from "react";
import {
  MDBCard,
  MDBCardHeader,
  MDBCardTitle,
  MDBCardBody,
} from "mdb-react-ui-kit";
import { useRecoilState } from "recoil";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { errorState, useGameBrandingQuery, useGameDataQuery } from "../settings/Settings.state";
import { Alert, Refresher, SidebarLayout } from "../common";
import AlertDisplay from "../common/AlertDisplay";
import { Row } from "../App.styles";
import BrandingPreview from "./BrandingPreview";
import BrandingForm from "./BrandingForm";
import BrandingPlaceholder from "./BrandingPlaceholder";
import { withPlaceholder } from "../common";

const Branding = () => {
  const { t } = useTranslation();
  const useQuery = () => useGameBrandingQuery();
  const { game_id } = useParams();
  const { data } = useGameDataQuery(game_id);
  const { grey_enabled } = data?.game || {};
  const [errorMessage, setErrorMessage] = useState("");
  const [error] = useRecoilState(errorState(game_id));
  const errorFromState = Array.isArray(error) ? error.join(", ") : error;
  const [branding] = useQuery();
  
  return (
    <>
      <AlertDisplay />
      <Row>
        <SidebarLayout message={t("These settings apply to your game You can change them anytime, even during the game.")}>
          {
            (errorFromState || errorMessage) && (
              <Alert color="error">{errorFromState || errorMessage}</Alert>
            )
          }
          <MDBCard>
            <MDBCardHeader>
              <MDBCardTitle>{t('Game Branding')}</MDBCardTitle>
            </MDBCardHeader>
            <MDBCardBody>
              <BrandingPreview setErrorMessage={setErrorMessage} />
              {grey_enabled && branding && <BrandingForm useQuery={useQuery} />}
            </MDBCardBody>
          </MDBCard>
        </SidebarLayout>
        <Refresher />
      </Row>
    </>
  );
};

export default withPlaceholder(Branding, BrandingPlaceholder);
